import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { ComponentBase} from '@definitiv-packages/angular-dba-library';
import { Document, DocumentService } from '@definitiv-packages/angular-documents-library';
import { ProjectLanguage } from '../../types/ProjectLanguage';
import { SafetyPointModelView } from '../../types/safety-point-model';

import { DocumentDataType } from '../../types/document-data-type-enum';

@Component({
  selector: 'app-show-safetypoint',
  templateUrl: './show-safetypoint.component.html',
  styleUrls: ['./show-safetypoint.component.scss'],
  standalone: false
})
export class ShowSafetyPointComponent extends ComponentBase<ProjectLanguage> implements OnInit, OnDestroy {
  
  /* diese Werte müssen aus einer Config geholt werden */
  public withelectronicID:boolean=false;
  public withassetlink:boolean=true;
  public withgeolocation:boolean=false;
  public widthformular:boolean=false;
  /*---------------------------------*/
  
  public Title: string = "";
  public safetyPoint: SafetyPointModelView;

  public documentList: Document[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SafetyPointModelView,
    public dialogRef: MatDialogRef<ShowSafetyPointComponent>,
    
    
    private documentService: DocumentService,
    
    private dialog: MatDialog,
    
  ) {
    super();
    
    this.safetyPoint = data
  }

  public async ngOnInit(): Promise<void> {
    this.loading = true;
    var resultList = await Promise.all([
      
      this.safetyPoint?.SafetyPointId ? this.documentService.getFilteredList({ DataTypeID: DocumentDataType.SafetyPoint, DataID: this.safetyPoint.SafetyPointId }) : Promise.resolve([]),
      

    ]);

    this.Title = this.languageService.getText(this.language.safetypointshow);

    this.documentList = resultList[0];

    this.loading = false;
  }

  public ngOnDestroy(): void {
    
  }

   public async Save(): Promise<void> {
      
    try {
      this.loading = true;
  
      
          await this.documentService.setList(DocumentDataType.SafetyPoint, this.safetyPoint.SafetyPointId, this.documentList);
          this.loading = false;
          this.dialogRef.close(this.safetyPoint);
      }catch {
          this.loading = false;
      }
    }
}
